<template>
    <v-dialog v-model="dialog" width="800px">
        <v-card>
            <v-card-title class="justify-center">commission details</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-row dense>
                    <v-col cols=3 class="font-weight-bold center">Rental contract</v-col> 
                    <v-col cols=9>{{ huov.huov_code }}</v-col> 
                </v-row>
                <v-row dense>
                    <v-col cols=3 class="font-weight-bold">Accommodation</v-col> 
                    <v-col cols=9>{{huov.huis_code }}</v-col> 
                </v-row>
                <v-row dense>
                    <v-col cols=3 class="font-weight-bold">Contract</v-col> 
                    <v-col cols=9>{{huov.cttp_nr}} {{ huov.type }}</v-col> 
                </v-row>
                <v-row dense>
                    <v-col cols=3 class="font-weight-bold">Guest rent (excl)</v-col> 
                    <v-col cols=9>{{huov.guest_excl}}</v-col> 
                </v-row>
                <v-row dense>
                    <v-col cols=3 class="font-weight-bold">Host rent (excl)</v-col> 
                    <v-col cols=9>{{huov.host_excl}}</v-col> 
                </v-row>
                <v-row dense>
                    <v-col cols=3 class="font-weight-bold">Total for commission</v-col> 
                    <v-col cols=9>{{huov.voor_commissie}}</v-col> 
                </v-row>
                <v-row dense>
                    <v-col cols=3 class="font-weight-bold">Calculation</v-col> 
                    <v-col cols=9>{{huov.calculation}}</v-col> 
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn color="primary" small @click="dialog=false">Close</v-btn>
            </v-card-actions>
        </v-card> 
    </v-dialog>
</template>

<script>
    export default {
        components: {
        },
        data() {
            return {
                dialog: false,
                huov: {}
            }
        },
        methods: { 
            openDialog(huov) {
                this.huov = huov;
                this.dialog = true;
            },
        }
    }
</script>

